<script>
    import { onMount } from "svelte";

    import { querystring } from "svelte-spa-router";

    import {
        goBack,
        goToURL,
        showError,
        showException,
        signOut,
    } from "../../Utils/utilFunctions.svelte";

    import { user } from "../../stores";

    import { apiMethods } from "../../Services/index.svelte";

    import Button from "../../Components/Common/Button.svelte";
    import SigninInput from "./components/SigninInput.svelte";
    import ErrorModal from "../../Components/Common/ErrorModal.svelte";
    import PageLoading from "../../Components/Common/PageLoading.svelte";
    import { PasswordInput } from "../../Components/Common/index.svelte";

    let isLoadingResetInfo = false,
        isResettingPwd = true,
        isResponseSuccess = false,
        pwdData = {},
        newPwd = "",
        confirmPwd = "",
        pwdErr = "",
        confirmPwdErr = "",
        error = "";

    const pwdRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;

    $: isValidPwd = newPwd ? pwdRegex.test(newPwd) : false;

    $: isPwdMatched = newPwd && confirmPwd ? newPwd === confirmPwd : true;

    $: isSubmitBtnDisabled = isResettingPwd || !isValidPwd || !isPwdMatched;

    onMount(async () => {
        if ($querystring) await getSetPwdStatus();
        else goBack();
        // isResponseSuccess = true;
    });

    const getSetPwdStatus = async () => {
        pwdData = _formatDataByQuery();

        isLoadingResetInfo = true;

        await apiMethods.getMethod
            .getResetPwd(pwdData)
            .then((res) => {
                isResettingPwd = false;
                isResponseSuccess = res.toString().toLowerCase() === "true";
            })
            .catch((err) => {
                isResettingPwd = false;
                showException(err);
            });

        isLoadingResetInfo = false;
    };

    const submitResetPassword = () => {
        if (_checkPwdValidation()) resetPassword();
        // else _updateFieldsStyle();
    };

    const resetPassword = () => {
        isResettingPwd = true;

        pwdData.password = newPwd;

        apiMethods.putMethod
            .updatePassword(pwdData)
            .then((res) => {
                isResettingPwd = false;
                if (res) {
                    if ($user.id) {
                        signOut({ reason: "Reset password and sign out" });
                        goToURL("/");
                    } else goToURL("/");
                } else showError("Failed to update password");
            })
            .catch((err) => {
                showException(err);
                isResettingPwd = false;
            });
    };

    // HELPER FUNCTIONS
    const _formatDataByQuery = () => {
        const queryArr = $querystring.split("&");

        if (queryArr.length == 2) {
            if (
                queryArr[0].substring(0, 2) == "e=" &&
                queryArr[1].substring(0, 2) == "c="
            )
                return {
                    code: queryArr[1].slice(2),
                    email: queryArr[0].slice(2),
                };
            else if (
                queryArr[0].substring(0, 2) == "c=" &&
                queryArr[1].substring(0, 2) == "e="
            )
                return {
                    code: queryArr[0].slice(2),
                    email: queryArr[1].slice(2),
                };
            else goBack();
        } else goBack();
    };

    const _checkPwdValidation = () => {
        return newPwd && confirmPwd && isValidPwd && isPwdMatched;
    };

    const _updateFieldsStyle = () => {
        const newPwdField = document.getElementById("New password");
        const confirmPwdField = document.getElementById("Confirm password");

        if (!newPwd || newPwd.length < 8 || newPwd !== confirmPwd) {
            newPwdField.style.outline = "2px solid red";
            if (!newPwd) pwdErr = "Missing new password";
            if (newPwd.length < 8)
                pwdErr = "Password must be at least 8 digits";
            if (newPwd !== confirmPwd) pwdErr = "Passwords not matched";
        }

        if (!confirmPwd || confirmPwd.length < 8 || newPwd !== confirmPwd) {
            confirmPwdField.style.outline = "2px solid red";
            if (!confirmPwd) confirmPwdErr = "Missing confirm password";
            if (confirmPwd.length < 8)
                confirmPwdErr = "Password must be at least 8 digits";
            if (newPwd !== confirmPwd) confirmPwdErr = "Passwords not matched";
        }
    };
</script>

<div class="flex-1 flex flex-col items-center w-full h-full p-6 showBG">
    <div class="flex items-center px-4 py-2">
        <img src="/favicon.png" alt="" class="w-[48px] h-[48px]" />
        <p class="text-primary text-2xl font-bold title-font pl-4">Anaemate</p>
    </div>

    {#if isLoadingResetInfo}
        <PageLoading />
    {:else}
        <div class="flex flex-1 items-center justify-evenly w-full">
            <div class="artboard w-auto h-auto p-6 shadow-lg">
                <div class="flex flex-col items-center gap-y-4">
                    {#if !isResponseSuccess}
                        <p class="text-xl text-bold">
                            Unable to reset your password, please try again or
                            contact support if the issue persists.
                        </p>
                        <Button
                            clickFunc={goBack}
                            manualClass={isResettingPwd ? "loading" : ""}
                            isDisabled={isResettingPwd}
                        >
                            Back
                        </Button>
                    {:else}
                        <p class="text-[24px] font-bold text-gray-600">
                            Reset password
                        </p>

                        <p class="text-xl text-bold">
                            Please enter your new password below:
                        </p>

                        <div class="flex flex-col gap-y-2 flex-1 w-full">
                            <p>New Password</p>
                            <PasswordInput bind:value={newPwd} isRequired />
                        </div>

                        <div class="flex flex-col gap-y-2 flex-1 w-full">
                            <p>Confirm Password</p>
                            <PasswordInput
                                bind:value={confirmPwd}
                                pwdValue={newPwd}
                                isRequired
                                isConfirm
                            />
                        </div>

                        <!-- {#if !isPwdMatched}
                            <p class="text-error flex-1 w-full">
                                Password not matched
                            </p>
                        {/if} -->

                        <div class="flex gap-x-4">
                            <Button
                                manualClass={"btn-error"}
                                clickFunc={goBack}
                            >
                                Cancel
                            </Button>
                            <Button
                                clickFunc={submitResetPassword}
                                isDisabled={isSubmitBtnDisabled}
                                manualClass={isResettingPwd ? "loading" : ""}
                            >
                                Submit
                            </Button>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .artboard {
        background-color: #f7f7f7;
        border: 1px solid rgba(65, 91, 63, 0.25);
        box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1);
        border-radius: 15px;
    }

    .showBG {
        height: 100vh;
        background-image: url("/imgs/bg_signIn.png");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: bottom;
        background-size: contain;
    }
</style>
